import { getCurrentUser } from 'domains/current_user';
import ky from 'ky';
import { MonthlyTotalAsset } from 'types';
import DEFAULT_OPTION from './default_option';

type MonthlyTotalAssetsResponse = {
  monthly_total_assets: MonthlyTotalAsset[];
};

type SearchMonthlyTotalAssetResponse = {
  monthly_total_asset: MonthlyTotalAsset | null;
};

export const getMonthlyTotalAssets =
  async (): Promise<MonthlyTotalAssetsResponse> => {
    const currentUser = getCurrentUser();

    const options = {
      ...DEFAULT_OPTION,
      headers: {
        'access-token': currentUser?.accessToken,
        client: currentUser?.client,
        uid: currentUser?.uid,
      },
      throwHttpErrors: true,
    };

    const response = await ky.get('monthly_total_assets', options);

    return response.json();
  };

type MonthlyTotalAssetResponse = {
  monthly_total_asset: MonthlyTotalAsset;
};

export const getMonthlyTotalAsset = async (
  id: number,
): Promise<MonthlyTotalAssetResponse> => {
  const currentUser = getCurrentUser();

  const options = {
    ...DEFAULT_OPTION,
    headers: {
      'access-token': currentUser?.accessToken,
      client: currentUser?.client,
      uid: currentUser?.uid,
    },
    throwHttpErrors: true,
  };

  const response = await ky.get(`monthly_total_assets/${id}`, options);

  return response.json();
};

export const postMonthlyTotalAsset = async (
  monthlyTotalAsset: MonthlyTotalAsset,
): Promise<MonthlyTotalAssetResponse> => {
  const currentUser = getCurrentUser();

  const options = {
    ...DEFAULT_OPTION,
    headers: {
      'access-token': currentUser?.accessToken,
      client: currentUser?.client,
      uid: currentUser?.uid,
    },
    json: { monthly_total_asset: monthlyTotalAsset },
    throwHttpErrors: true,
  };

  const response = await ky.post('monthly_total_assets', options);

  return response.json();
};

export const pacthMonthlyTotalAsset = async (
  monthlyTotalAsset: MonthlyTotalAsset,
): Promise<MonthlyTotalAssetResponse> => {
  const currentUser = getCurrentUser();

  const options = {
    ...DEFAULT_OPTION,
    headers: {
      'access-token': currentUser?.accessToken,
      client: currentUser?.client,
      uid: currentUser?.uid,
    },
    json: { monthly_total_asset: monthlyTotalAsset },
    throwHttpErrors: true,
  };

  const response = await ky.patch(
    `monthly_total_assets/${monthlyTotalAsset.id}`,
    options,
  );

  return response.json();
};

type deleteMonthlyTotalAssetResponse = Record<string, never>;

export const deleteMonthlyTotalAsset = async (
  id: number,
): Promise<deleteMonthlyTotalAssetResponse> => {
  const currentUser = getCurrentUser();

  const options = {
    ...DEFAULT_OPTION,
    headers: {
      'access-token': currentUser?.accessToken,
      client: currentUser?.client,
      uid: currentUser?.uid,
    },
    throwHttpErrors: true,
  };

  const response = await ky.delete(`monthly_total_assets/${id}`, options);

  return response.json();
};

export const searchMonthlyTotalAsset = async (
  year: number,
  month: number,
): Promise<SearchMonthlyTotalAssetResponse> => {
  const currentUser = getCurrentUser();

  const options = {
    ...DEFAULT_OPTION,
    headers: {
      'access-token': currentUser?.accessToken,
      client: currentUser?.client,
      uid: currentUser?.uid,
    },
    searchParams: { year, month },
    throwHttpErrors: true,
  };

  const response = await ky.get('monthly_total_assets/search', options);

  return response.json();
};
